module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar navbar-default"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#/"
    },
    on: {
      "click": function($event) {
        _vm.mobileNavOpen = false
      }
    }
  }, [_vm._v("Ricardo van der Heijden")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-lg mobile-nav-toggle",
    on: {
      "click": function($event) {
        _vm.mobileNavOpen = !_vm.mobileNavOpen
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon",
    class: {
      'glyphicon-remove': _vm.mobileNavOpen, 'glyphicon-menu-hamburger': !_vm.mobileNavOpen
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    class: { in: _vm.mobileNavOpen
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, _vm._l((_vm.navigation), function(item) {
    return _c('li', {
      class: {
        active: _vm.activePage == item.page
      },
      on: {
        "click": function($event) {
          _vm.mobileNavOpen = false
        }
      }
    }, [_c('a', {
      attrs: {
        "href": '#/' + item.page
      }
    }, [_vm._v(_vm._s(item.title))])])
  }))]), _vm._v(" "), _c('div')])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bcf6a6f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mp-navigation.vue
// module id = 382
// module chunks = 1